import { Button, Heading, HStack, Stack, Text } from '@chakra-ui/react';
import { Show } from '@pelicargo/ui';
import { PermissionLevel } from '@pelicargo/utils';
import { Link as RRLink } from 'react-router-dom';

import { FilterCrud } from '../components/FilterCrud';
import { useAuth } from '../context/AuthProvider';

export const ConfigurationScreen = () => {
  const auth = useAuth();

  // Superadmin only. Deliberately stricter than the `isSuperAdminOrSystemTenant` gate the theme
  // procedures enforce: editing another brand's look is rare and destructive-by-accident, so the
  // link is not advertised to every admin on the system tenant even though the API would serve
  // them. The server remains the control.
  const showCustomerTheme = auth.permission === PermissionLevel.SUPERADMIN;

  return (
    <Stack spacing="2" maxH="100vh" h="100vh">
      <Stack p="4" zIndex="2">
        <HStack justifyContent="space-between">
          <Heading variant="h5">Advanced Configuration</Heading>
          <HStack>
            <Button as={RRLink} to="/rules-data">
              Edit Rules
            </Button>
            <Button as={RRLink} to="/configuration/snippets">
              Filter Snippets
            </Button>
            <Button as={RRLink} to="/configuration/general">
              General Configuration
            </Button>
            <Show if={showCustomerTheme}>
              <Button as={RRLink} to="/configuration/theme">
                Customer Theme
              </Button>
            </Show>
            <Show if={auth.permission === PermissionLevel.SUPERADMIN}>
              <Button as={RRLink} to="/configuration/credentials">
                Credentials
              </Button>
            </Show>
          </HStack>
        </HStack>
        <Text>
          ⚠️ Warning: This page contains the sharp knives. Be careful, and if you don't know what you're doing, it's
          better to back out and ask for some advice.
        </Text>
      </Stack>
      <FilterCrud />
    </Stack>
  );
};
